function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import "./dashboard.css";
import { Chart } from "react-google-charts";
import { convertSecToHoursAndMinutesWithTextShortForm } from "../utils";
var chartColor = [{
  color: "#10b9a9",
  backgroundColor: "rgb(16 185 169 / 22%)",
  fontColor: "#10b9a9"
}, {
  color: "#f59593",
  backgroundColor: "rgb(245 149 147 / 32%)",
  fontColor: "#f59593"
}, {
  color: "#787877",
  backgroundColor: "rgb(120 120 119 / 11%)",
  fontColor: "#787877"
}, {
  color: "#C0901D",
  backgroundColor: "rgb(192 144 29 / 37%)",
  fontColor: "#C0901D"
}, {
  color: "#7bd8e6",
  backgroundColor: "rgb(123 216 230 / 26%)",
  fontColor: "#7bd8e6"
}, {
  color: "#F5EF93",
  backgroundColor: "rgb(245 239 147 / 42%)",
  fontColor: "rgb(177 166 3)"
}];
export var chartSelectedColor = {
  color: "rgb(119 145 241)",
  backgroundColor: "rgb(131 188 236 / 77%)",
  fontColor: "rgb(3 88 177)"
};
var TopAppsAndWebsites = function TopAppsAndWebsites(props) {
  var teamTopAppsAndWebsite = props.teamTopAppsAndWebsite,
    organisationSettings = props.organisationSettings;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focusedRow = _React$useState2[0],
    setFocusedRow = _React$useState2[1];
  var appTrackingCheck = organisationSettings.trackAppsAndWebsites;
  var teamTopAppsAndWebsiteChart = teamTopAppsAndWebsite.reduce(function (acc, curr) {
    var title = curr.title,
      totalTime = curr.totalTime;
    var timeInHrs = convertSecToHoursAndMinutesWithTextShortForm(Number(totalTime));
    return [].concat(_toConsumableArray(acc), [[title, totalTime, "<div class=\"apps-tootlip\">\n            <span class=\"apps-tootlip-title\">".concat(title, "</span>\n            <br>\n            <span class=\"apps-tootlip apps-tootlip-time\">Time: ").concat(timeInHrs, "</span>\n          </div>")]]);
  }, [["Website", "Hours per Day", {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }]]);
  return /*#__PURE__*/React.createElement("div", {
    className: "dashboard-table-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head-website-list"
  }, "Top Used Apps"), /*#__PURE__*/React.createElement("div", {
    className: "dashboard-chart-section-top"
  }, appTrackingCheck === true ? teamTopAppsAndWebsite.length !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "top-apps-and-websites-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dashboard-website-list"
  }, teamTopAppsAndWebsite.map(function (topApp, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "website-list",
      style: focusedRow === index ? {
        border: "1px solid ".concat(chartSelectedColor.color),
        backgroundColor: chartSelectedColor.backgroundColor
      } : {
        border: "1px solid ".concat(chartColor[index].color),
        backgroundColor: chartColor[index].backgroundColor
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: topApp.icon,
      alt: "Logo",
      className: "website-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "website-name"
    }, topApp.title));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "top-apps-and-websites-chart"
  }, /*#__PURE__*/React.createElement("div", {
    className: "website-chart"
  }, /*#__PURE__*/React.createElement(Chart, {
    width: "100%",
    height: "250px"
    // marginTop={"300px"}
    ,
    bottom: "0px",
    left: "0px",
    right: "0px",
    position: "absolute",
    chartType: "PieChart",
    loader: /*#__PURE__*/React.createElement("div", null, "Loading Chart"),
    data: teamTopAppsAndWebsiteChart,
    options: {
      legend: "none",
      pieSliceText: "none",
      chartArea: {
        width: "95%",
        height: "90%",
        bottom: "0px",
        left: "0px",
        right: "0px"
      },
      slices: {
        0: {
          color: "#10b9a9"
        },
        1: {
          color: "#f59593"
        },
        2: {
          color: "#787877"
        },
        3: {
          color: "#C0901D"
        },
        4: {
          color: "#7bd8e6"
        },
        5: {
          color: "#F5EF93"
        }
      },
      pieHole: 0.4,
      tooltip: {
        isHtml: true,
        trigger: "visible"
      }
    },
    chartEvents: [{
      eventName: "ready",
      callback: function callback(_ref) {
        var chartWrapper = _ref.chartWrapper,
          google = _ref.google;
        //setLoaded(true);
        var chart = chartWrapper.getChart();
        google.visualization.events.addListener(chart, "onmouseover", function (e) {
          var row = e.row;
          setFocusedRow(row);
        });
        google.visualization.events.addListener(chart, "onmouseout", function () {
          if (focusedRow) {
            setFocusedRow(null);
          }
        });
      }
    }]
  })))) :
  /*#__PURE__*/
  // <div>
  React.createElement("div", {
    className: "overview-no-data-text overview-no-data-grid"
  }, "No data found")
  // {/* </div> */}
  :
  /*#__PURE__*/
  // <div>
  React.createElement("div", {
    className: "overview-no-data-text overview-no-data-grid"
  }, "Track apps and websites is disabled")
  // </div>
  ));
};
export default TopAppsAndWebsites;